/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { useState } from 'react'
import { toAbsoluteUrl, KTSVG } from '../../_metronic/helpers'
import moment from 'moment'

// Formats a mobile number with masking
/**
 * FormatMobileNumber
 *
 * Formats a 10-digit mobile number by masking parts with '**'.
 * Returns 'Invalid mobile number' for invalid input.
 *
 * Props:
 * - number: Mobile number string
 */
const FormatMobileNumber = ({ number }) => {
  // Check if the input is a valid 10-digit number
  if (/^\d{10}$/.test(number)) {
    // Split the number into three parts and add "**" in between
    const formattedNumber = number.slice(0, 2) + "**" + number.slice(2, 4) + "**" + number.slice(4, 2);
    return formattedNumber;
  } else {

    // Handle invalid input
    return "Invalid mobile number";
  }
}

// Renders user info cell with avatar, name, and email
/**
 * UserInfoCell
 *
 * Displays user avatar, name, and email in a table cell.
 *
 * Props:
 * - user: User object with avatar, name, email, initials
 */
const UserInfoCell = ({ user }) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
      <a href='#'>
        {user.avatar ? (
          <div className='symbol-label'>
            <img src={toAbsoluteUrl(`/media/${user.avatar}`)} alt={user.name} className='w-100' />
          </div>
        ) : (
          <div className={clsx('symbol-label fs-3', `bg-light-${user.initials?.state}`, `text-${user.initials?.state}`)} >
            {user.initials?.label}
          </div>
        )}
      </a>
    </div>
    <div className='d-flex flex-column'>
      <a href='#' className='text-gray-800 text-hover-primary mb-1'>
        {user.name}
      </a>
      <span>{user.email}</span>
    </div>
  </div>
)
// Renders logo/avatar cell
/**
 * Logo
 *
 * Displays a logo or default image in a table cell.
 *
 * Props:
 * - data: Image URL string
 */
const Logo = ({ data }) => {

  return <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
      <a href='#'>
        {data ? (
          <div className='symbol-label'>
            <img src={data} className='w-100' alt='label' />
          </div>
        ) : (
          <div className='symbol-label'>
            <img src={toAbsoluteUrl(`/media/svg/files/blank-image.svg`)} className='w-100' alt='blank' />
          </div>
        )}
      </a>
    </div>

  </div>
}
// Renders product info cell
/**
 * ProductInfoCell
 *
 * Displays product image and name in a table cell.
 *
 * Props:
 * - user: Product object (not used in current implementation)
 */
const ProductInfoCell = ({ user }) => (
  <div className="d-flex align-items-center">
    <a href="#" className="symbol symbol-50px">
      <span className="symbol-label" style={{ backgroundImage: `url('${toAbsoluteUrl('/media//stock/ecommerce/1.gif')})` }}></span>
    </a>

    <div className="ms-5">

      <a href="#" className="text-gray-800 text-hover-primary fs-5 fw-semibolder"
      >Product 1</a>

    </div>
  </div>
)
// Renders status cell (Enabled/Disabled)
/**
 * StatusCell
 *
 * Displays a badge for enabled/disabled status.
 *
 * Props:
 * - status: Status value (1 for enabled)
 */
const StatusCell = ({ status }) => {
  return <>{
    Number(status) === 1 ?
      <div className='badge badge-light-success fw-semibolder'>Enabled</div>
      : <div className='badge badge-light-danger fw-semibolder'>Disabled</div>
  }</>

}

// Formats date to 'DD MMM YY'
/**
 * Dateformet
 *
 * Formats a date string to 'DD MMM YY'.
 *
 * Props:
 * - data: Date string
 */
const Dateformet = ({ data }) => {

  return moment(data).format('DD MMM YY')
}

// Formats date and time to 'DD MMM YY, hh:mm A'
/**
 * DateTimeData
 *
 * Formats a date string to 'DD MMM YY, hh:mm A'.
 *
 * Props:
 * - data: Date string
 */
const DateTimeData = ({ data }) => {

  return moment(data).format('DD MMM YY ,hh:mm A')
}
// Formats time to 'hh:mm A'
/**
 * Timeformat
 *
 * Formats a time string to 'hh:mm A'.
 *
 * Props:
 * - data: Time string
 */
const Timeformat = ({ data }) => {

  //return moment(data, 'HH:mm').format('hh:mm A');
  const parsedTime = moment(data);

  // Extract the time part and format it in 12-hour format
  return parsedTime.format('hh:mm A');
}
const ColumnStyle = ({ lenght, data }) => {

  return <>

    <div className='badge badge-light-success fw-semibolder'>Enabled</div>
    <div className='badge badge-light-success fw-semibolder'>Enabled</div>
    <div className='badge badge-light-success fw-semibolder'>Enabled</div>
    <div className='badge badge-light-success fw-semibolder'>Enabled</div>
  </>
}
// Displays truncated or full character string on hover
/**
 * CharacterDisplay
 *
 * Shows truncated character string, reveals full string on hover.
 *
 * Props:
 * - character: String to display
 * - count: Number of characters to show before truncation
 */
const CharacterDisplay = ({ character, count }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
      className="character-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className=''>{isHovered ? character : character?.substring(0, count) + '...'}</div>
      {/* <div>{character?.substring(0, count) + '...'}</div> */}
      {/* <div style={{ display: `${isHovered ? 'block' : 'none'}` }}>{character}</div> */}
    </div>
  );
};
// Displays and copies a URL, shows check icon when copied
/**
 * CopyUrl
 *
 * Displays a truncated URL and allows copying to clipboard.
 * Shows a check icon when copied.
 *
 * Props:
 * - url: URL string
 * - count: Number of characters to show before truncation
 */
const CopyUrl = ({ url, count }) => {
  const [isCopied, setIsCopied] = useState(false);
  const truncatedUrl = url.length > count ? url.slice(0, count) + '...' : url;

  const handleCopyClick = () => {
    // Copy the refKey to the clipboard
    navigator.clipboard.writeText(url).then(() => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    });
  };
  return (
    <div className='d-flex'>
      <div className='me-2'>{truncatedUrl} </div>
      <div className='text-danger fw-semibold'>
        {isCopied ? <i class="bi text-success fs-5 bi-check-lg"></i> :
          <i
            className="bi bi-clipboard  fs-5 fw-semibold cursor-pointer "
            onClick={handleCopyClick}
          ></i>

        }
      </div>
    </div>
  );
};
// const SmsStatus = ({ data }) => {
//   if ((data.sms_status == '1' && data.sms_template == '') || (data.sms_status == '0' && data.sms_template != '')) {
//     return <KTSVG path='/media/icons/duotune/arrows/gen044.svg' className='svg-icon svg-icon-2 svg-icon-warning' />

//   } else if (data.sms_status == '0' && data.sms_template == '') {
//     return < KTSVG path='/media/icons/duotune/arrows/arr015.svg' className='svg-icon svg-icon-2 svg-icon-danger' />
//   } else {
//     return <KTSVG path='/media/icons/duotune/arrows/arr016.svg' className='svg-icon svg-icon-2 svg-icon-success' />
//   }

// }
// const EmailStatus = ({ data }) => {
//   if ((data.sms_status == '1' && data.sms_template == '') || (data.sms_status == '0' && data.sms_template != '')) {
//     return <KTSVG path='/media/icons/duotune/arrows/gen044.svg' className='svg-icon svg-icon-2 svg-icon-warning' />

//   } else if (data.sms_status == '0' && data.sms_template == '') {
//     return < KTSVG path='/media/icons/duotune/arrows/arr015.svg' className='svg-icon svg-icon-2 svg-icon-danger' />
//   } else {
//     return <KTSVG path='/media/icons/duotune/arrows/arr016.svg' className='svg-icon svg-icon-2 svg-icon-success' />
//   }

// }
// const WattsappStatus = ({ data }) => {
//   if ((data.whatsapp_status == '1' && data.whatsapp_template == '') || (data.whatsapp_status == '0' && data.whatsapp_template != '')) {
//     return <KTSVG path='/media/icons/duotune/arrows/gen044.svg' className='svg-icon svg-icon-2 svg-icon-warning' />

//   } else if (data.whatsapp_status == '0' && data.whatsapp_template == '') {
//     return < KTSVG path='/media/icons/duotune/arrows/arr015.svg' className='svg-icon svg-icon-2 svg-icon-danger' />
//   } else {
//     return <KTSVG path='/media/icons/duotune/arrows/arr016.svg' className='svg-icon svg-icon-2 svg-icon-success' />
//   }

// }
// {/* <img src="/media/icons/duotune/arrows/arr016.svg" />                        
//     <img src="/media/icons/duotune/arrows/arr015.svg" />
//     <img src="/media/icons/duotune/general/gen044.svg" /> */}
// Renders courier status icon
/**
 * CourierStatus
 *
 * Displays a success or danger icon based on courier status.
 *
 * Props:
 * - status: Status value (2 for danger)
 */
const CourierStatus = ({ status }) => {

  if (Number(status) === 2) {

    return <KTSVG path='/media/icons/duotune/arrows/arr015.svg' className='svg-icon svg-icon-2 svg-icon-danger' />
  } else {

    return <KTSVG path='/media/icons/duotune/arrows/arr016.svg' className='svg-icon svg-icon-2 svg-icon-success' />
  }

}
// Renders address status symbol
/**
 * AddressStatus
 *
 * Displays a symbol for address status (A, V, U, etc.).
 *
 * Props:
 * - status: Status value (1-5)
 */
const AddressStatus = ({ status }) => {

  switch (status) {
    case 1:
      return <div className="symbol symbol-25px symbol-circle  me-2">
        <span className="symbol-label fs-6 fw-semibold text-white bg-danger">A</span>
      </div>

    case 2:
      return <div class="d-flex symbol symbol-25px symbol-circle my-2 me-2">
        <span class="symbol-label fs-7 fw-semibold text-white bg-success me-2">
          <i class="fa fa-check text-white" aria-hidden="true"></i>
        </span>
      </div>

    case 3:
      return <div className="symbol symbol-25px symbol-circle  me-2">
        <span className="symbol-label fs-6 fw-semibold text-white bg-danger">V</span>
      </div>

    case 4:
      return <div className="symbol symbol-25px symbol-circle  me-2">
        <span className="symbol-label fs-6 fw-semibold text-white bg-info">U</span>
      </div>

    case 5:
      return <div class="d-flex symbol symbol-25px symbol-circle my-2 me-2">
        <span class="symbol-label fs-7 fw-semibold text-white bg-info">
          <i class="fa fa-dot-circle text-white" aria-hidden="true"></i>
        </span>
      </div>

    default:
      return <></>;

  }
}
// Renders date cell badge
/**
 * DateCell
 *
 * Displays a badge with the date value.
 *
 * Props:
 * - date: Date string
 */
const DateCell = ({ date }) => {
  <div className='badge badge-light-success fw-semibolder'>{date}</div>
}

const RedemptionDate = ({ value }) => {
  return value;
}

export {
  CopyUrl,
  AddressStatus,
  DateTimeData,
  CharacterDisplay,
  UserInfoCell,
  ProductInfoCell,
  StatusCell,
  DateCell,
  Timeformat,
  Logo, ColumnStyle,
  CourierStatus,
  RedemptionDate,
  Dateformet,
  FormatMobileNumber
}
